// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.103.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.103.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

body {
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #f9fafb;
  color: #1f2937;
}

#host-root {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

#main-layout {
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100vh;
  max-width: 1400px;
  margin: 0 auto;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  overflow: hidden;
}

#layout-header {
  background: #c1f1f436;
    color: #471de0;
  padding: 1rem 2rem 0 2rem;
  border-bottom: 1px solid #7fb3d5;
}

.header-content {
  margin-bottom: 0.75rem;
}

.header-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.header-title {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.025em;
}

.github-icon-link {
  display: flex;
  align-items: center;
  color: #471de0;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.github-icon-link:hover {
  opacity: 0.7;
}

.github-icon-link svg {
  width: 24px;
  height: 24px;
}

.header-subtitle {
  font-size: 1rem;
  opacity: 0.8;
  font-weight: 400;
  margin-bottom: 0;
  color: #374151;
}

#layout-nav {
  display: flex;
  gap: 0;
  border-bottom: 2px solid rgba(127, 179, 213, 0.3);
}

.nav-item {
  background: transparent;
  border: none;
  color: #374151;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.2s ease;
  position: relative;
  top: 2px;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.5);
  color: #1f2937;
}

.nav-item.active {
  background: transparent;
  color: #1f2937;
  border-bottom-color: #3b82f6;
  font-weight: 600;
}

#layout-body {
  padding: 2rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  min-height: 0;
}

#content-area {
  width: 100%;
  max-width: 1000px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#readme-textarea {
  width: 100%;
  height: 100%;
  padding: 1.5rem;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  resize: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-family: 'Courier New', Consolas, monospace;
  font-size: 0.9rem;
  color: #1f2937;
  line-height: 1.6;
}

#content-area h1 {
  font-size: 1.875rem;
  margin-bottom: 1rem;
  color: #1f2937;
}

#content-area h2 {
  font-size: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 0.5rem;
}

#content-area h3 {
  font-size: 1.25rem;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  color: #4b5563;
}

#content-area p {
  margin-bottom: 1rem;
  line-height: 1.6;
  color: #374151;
}

#content-area ul, #content-area ol {
  margin-bottom: 1rem;
  padding-left: 2rem;
  line-height: 1.8;
}

#content-area li {
  margin-bottom: 0.5rem;
  color: #374151;
}

#content-area code {
  background: #f3f4f6;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-size: 0.9rem;
  font-family: 'Courier New', monospace;
  color: #991b1b;
}

#content-area pre {
  background: #1f2937;
  color: #f9fafb;
  padding: 1rem;
  border-radius: 6px;
  overflow-x: auto;
  margin-bottom: 1rem;
}

#content-area pre code {
  background: none;
  color: inherit;
  padding: 0;
}

#content-area strong {
  font-weight: 600;
  color: #1f2937;
}

#content-area a {
  color: #667eea;
  text-decoration: none;
}

#content-area a:hover {
  text-decoration: underline;
}

#layout-footer {
  background: #f3f4f6;
  border-top: 1px solid #e5e7eb;
  padding: 1rem 2rem;
  text-align: center;
}

#footer-content {
  font-size: 1rem;
  color: #6b7280;
}

.loading-message {
  text-align: center;
  padding: 3rem;
  color: #6b7280;
  font-size: 1.125rem;
}

.error-message {
  padding: 1.5rem;
  background: #fee2e2;
  border: 1px solid #ef4444;
  border-radius: 8px;
  color: #991b1b;
  margin: 1rem 0;
}

.error-message h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  color: #991b1b;
}

.remote-container {
  margin: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  html, body {
    height: 100vh;
    width: 100%;
  }

  #host-root {
    height: 100vh;
    width: 100%;
  }

  #main-layout {
    height: 100vh;
    max-width: 100%;
    box-shadow: none;
  }

  #layout-header {
    padding: 1rem 1rem 0 1rem;
  }

  .header-content {
    margin-bottom: 0.5rem;
  }

  #layout-nav {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .nav-item {
    padding: 0.5rem 1rem;
    flex: 0 0 auto;
    white-space: nowrap;
  }

  #layout-body {
    padding: 0.75rem;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  #content-area {
    height: 100%;
  }

  #readme-textarea {
    height: 100%;
    padding: 1rem;
  }

  .remote-container {
    height: 100%;
    overflow-y: auto;
  }

  #layout-footer {
    padding: 0.5rem 1rem;
    flex-shrink: 0;
  }
}

@media (max-width: 480px) {
  #layout-body {
    padding: 0.5rem;
  }

  #readme-textarea {
    padding: 0.75rem;
  }
}

`, "",{"version":3,"sources":["webpack://./host/src/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8FAA8F;EAC9F,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;IACnB,cAAc;EAChB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,+CAA+C;EAC/C,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\nbody {\n  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  background: #f9fafb;\n  color: #1f2937;\n}\n\n#host-root {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n#main-layout {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  height: 100vh;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  overflow: hidden;\n}\n\n#layout-header {\n  background: #c1f1f436;\n    color: #471de0;\n  padding: 1rem 2rem 0 2rem;\n  border-bottom: 1px solid #7fb3d5;\n}\n\n.header-content {\n  margin-bottom: 0.75rem;\n}\n\n.header-title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.25rem;\n}\n\n.header-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin: 0;\n  letter-spacing: -0.025em;\n}\n\n.github-icon-link {\n  display: flex;\n  align-items: center;\n  color: #471de0;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n}\n\n.github-icon-link:hover {\n  opacity: 0.7;\n}\n\n.github-icon-link svg {\n  width: 24px;\n  height: 24px;\n}\n\n.header-subtitle {\n  font-size: 1rem;\n  opacity: 0.8;\n  font-weight: 400;\n  margin-bottom: 0;\n  color: #374151;\n}\n\n#layout-nav {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid rgba(127, 179, 213, 0.3);\n}\n\n.nav-item {\n  background: transparent;\n  border: none;\n  color: #374151;\n  padding: 0.5rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.2s ease;\n  position: relative;\n  top: 2px;\n}\n\n.nav-item:hover {\n  background: rgba(255, 255, 255, 0.5);\n  color: #1f2937;\n}\n\n.nav-item.active {\n  background: transparent;\n  color: #1f2937;\n  border-bottom-color: #3b82f6;\n  font-weight: 600;\n}\n\n#layout-body {\n  padding: 2rem;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1;\n  min-height: 0;\n}\n\n#content-area {\n  width: 100%;\n  max-width: 1000px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n#readme-textarea {\n  width: 100%;\n  height: 100%;\n  padding: 1.5rem;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  resize: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  font-family: 'Courier New', Consolas, monospace;\n  font-size: 0.9rem;\n  color: #1f2937;\n  line-height: 1.6;\n}\n\n#content-area h1 {\n  font-size: 1.875rem;\n  margin-bottom: 1rem;\n  color: #1f2937;\n}\n\n#content-area h2 {\n  font-size: 1.5rem;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n  padding-bottom: 0.5rem;\n}\n\n#content-area h3 {\n  font-size: 1.25rem;\n  margin-top: 1.5rem;\n  margin-bottom: 0.75rem;\n  color: #4b5563;\n}\n\n#content-area p {\n  margin-bottom: 1rem;\n  line-height: 1.6;\n  color: #374151;\n}\n\n#content-area ul, #content-area ol {\n  margin-bottom: 1rem;\n  padding-left: 2rem;\n  line-height: 1.8;\n}\n\n#content-area li {\n  margin-bottom: 0.5rem;\n  color: #374151;\n}\n\n#content-area code {\n  background: #f3f4f6;\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  font-family: 'Courier New', monospace;\n  color: #991b1b;\n}\n\n#content-area pre {\n  background: #1f2937;\n  color: #f9fafb;\n  padding: 1rem;\n  border-radius: 6px;\n  overflow-x: auto;\n  margin-bottom: 1rem;\n}\n\n#content-area pre code {\n  background: none;\n  color: inherit;\n  padding: 0;\n}\n\n#content-area strong {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n#content-area a {\n  color: #667eea;\n  text-decoration: none;\n}\n\n#content-area a:hover {\n  text-decoration: underline;\n}\n\n#layout-footer {\n  background: #f3f4f6;\n  border-top: 1px solid #e5e7eb;\n  padding: 1rem 2rem;\n  text-align: center;\n}\n\n#footer-content {\n  font-size: 1rem;\n  color: #6b7280;\n}\n\n.loading-message {\n  text-align: center;\n  padding: 3rem;\n  color: #6b7280;\n  font-size: 1.125rem;\n}\n\n.error-message {\n  padding: 1.5rem;\n  background: #fee2e2;\n  border: 1px solid #ef4444;\n  border-radius: 8px;\n  color: #991b1b;\n  margin: 1rem 0;\n}\n\n.error-message h3 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  color: #991b1b;\n}\n\n.remote-container {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  html, body {\n    height: 100vh;\n    width: 100%;\n  }\n\n  #host-root {\n    height: 100vh;\n    width: 100%;\n  }\n\n  #main-layout {\n    height: 100vh;\n    max-width: 100%;\n    box-shadow: none;\n  }\n\n  #layout-header {\n    padding: 1rem 1rem 0 1rem;\n  }\n\n  .header-content {\n    margin-bottom: 0.5rem;\n  }\n\n  #layout-nav {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n  }\n\n  .nav-item {\n    padding: 0.5rem 1rem;\n    flex: 0 0 auto;\n    white-space: nowrap;\n  }\n\n  #layout-body {\n    padding: 0.75rem;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  #content-area {\n    height: 100%;\n  }\n\n  #readme-textarea {\n    height: 100%;\n    padding: 1rem;\n  }\n\n  .remote-container {\n    height: 100%;\n    overflow-y: auto;\n  }\n\n  #layout-footer {\n    padding: 0.5rem 1rem;\n    flex-shrink: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  #layout-body {\n    padding: 0.5rem;\n  }\n\n  #readme-textarea {\n    padding: 0.75rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
